module.exports = __webpack_public_path__ + "static/img/12.aecd5b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/sp/12.png
// module id = MmC9
// module chunks = 0